import { useEffect, useRef, useState } from "react";

import { ReactComponent as DownloadIcon } from "../../images/download.svg";
import { CSVLink } from "react-csv";
//import { API_BASE } from "core/Constants";
//import Modal from "./Modal";

const BillinMonthlyExporter = props => {
    const [progress, setProgress] = useState(false);
    const [downloadCSV, setDownloadCSV] = useState(false);

    const csvLinkRef = useRef(null);

    let disabled = true;
    if (props.data && props.data.length) {
        disabled = false;
    }

    let buttonProps = {};
    if (disabled) {
        buttonProps.className = "greyed-svg";
    }



    const download = () => {
        if (downloadCSV) {
            return;
        }

        if (disabled) {
            return;
        }

        setProgress(true);

        if (props.format === "csv") {
            setDownloadCSV(true);
        }


    };

    const downloadCompleted = () => {
        setDownloadCSV(false);
        setProgress(false);
    };

    useEffect(() => {
        if (downloadCSV) {
            if (csvLinkRef && csvLinkRef.current) {
                csvLinkRef.current.link.click();
                downloadCompleted();
            }
        }
    }, [downloadCSV]);

    const csvComp = downloadCSV ? (
        <CSVLink
            ref={csvLinkRef}
            data={props.data}
            headers={props.headers}
            filename={props.filename}
            style={{ display: "none" }}
            target=""
        />
    ) : (
        <></>
    );

    return (
        <>
            <div
                className="el icon exporter"
                onClick={() => {
                    download();
                }}
            >
                {csvComp}
                {progress ? (
                    <div className="loader">
                        <div className="lds-hourglass"></div>
                    </div>
                ) : (
                    <DownloadIcon {...buttonProps} />
                )}
            </div>
        </>
    );
};

export default BillinMonthlyExporter;
